export enum MM07PositioningPrecision {
    LOW = 'LOW',
    HIGH = 'HIGH'
}
